<template>
  <div>
    <moule1 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '1'"></moule1>
    <moule2 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '2'"></moule2>
    <moule3 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '3'"></moule3>
    <moule4 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '4'"></moule4>
    <moule5 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '5'"></moule5>
    <moule6 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '6'"></moule6>
    <moule7 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '7'"></moule7>
    <moule8 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '8'"></moule8>
    <moule9 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '9'"></moule9>
    <moule10 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '10'"></moule10>
    <moule11 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '11'"></moule11>
    <moule12 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '12'"></moule12>
    <moule13 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '13'"></moule13>
    <moule14 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '14'"></moule14>
    <moule15 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '15'"></moule15>
    <moule16 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '16'"></moule16>
    <moule17 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '17'"></moule17>
    <moule18 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '18'"></moule18>
    <moule19 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '19'"></moule19>
    <moule20 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '20'"></moule20>
    <contentCn :dominItem="dominItem" v-if="dominItem && dominItem.remark === '21'"></contentCn>
    <contentEn :dominItem="dominItem" v-if="dominItem && dominItem.remark === '22'"></contentEn>
    <contentJp :dominItem="dominItem" v-if="dominItem && dominItem.remark === '23'"></contentJp>
    <contentKr :dominItem="dominItem" v-if="dominItem && dominItem.remark === '24'"></contentKr>
  </div>
</template>
<script>
import contentEn from '../components/index/en'
import contentCn from '../components/index/cn'
import contentJp from '../components/index/jp'
import contentKr from '../components/index/kr'

import moule1 from '../components/index/mould1/index.vue'
import moule2 from '../components/index/mould2/index.vue'
import moule3 from '../components/index/mould3/index.vue'
import moule4 from '../components/index/mould4/index.vue'
import moule5 from '../components/index/mould5/index.vue'
import moule6 from '../components/index/mould6/index.vue'
import moule7 from '../components/index/mould7/index.vue'
import moule8 from '../components/index/mould8/index.vue'
import moule9 from '../components/index/mould9/index.vue'
import moule10 from '../components/index/mould10/index.vue'
import moule11 from '../components/index/mould11/index.vue'
import moule12 from '../components/index/mould12/index.vue'
import moule13 from '../components/index/mould13/index.vue'
import moule14 from '../components/index/mould14/index.vue'
import moule15 from '../components/index/mould15/index.vue'
import moule16 from '../components/index/mould16/index.vue'
import moule17 from '../components/index/mould17/index.vue'
import moule18 from '../components/index/mould18/index.vue'
import moule19 from '../components/index/mould19/index.vue'
import moule20 from '../components/index/mould20/index.vue'



import {getDomainName} from "@/api";

export default {
  components: {
    // contentEn, contentCn, contentJp, contentKr,
    contentCn,contentEn,contentJp,contentKr,
    moule1,moule2,moule3,moule4,moule5,moule6,moule7,
    moule8,moule9,moule10, moule11,moule12, moule13, moule14, moule15,moule16,
    moule17,moule18, moule19, moule20
  },
  data() {
    return {
      dominItem: undefined
    };
  },

  created() {
    setTimeout(() => {
      this.dominItem = JSON.parse(localStorage.getItem('dominItem'))
    }, 500)
  },

  methods: {

  },
};
</script>
<style lang="scss" scoped>

</style>
